import React, { useEffect, useState } from 'react'
import { local_storage_keys } from '../shared-constants/localstorage'

export const OtpContext = React.createContext({
  userPhoneNumber: '',
  setUserPhoneNumber: (key: any) => {},
  userNationalCode: '',
  setUserNationalCode: (key: any) => {},
  userBirthdate: '',
  setUserBirthdate: (key: string) => {},
  otpCode: '',
  setOtpCode: (key: any) => {},
  traceNo: '',
  setTraceNo: (key: string) => {},
  minutes: 0,
  setMinutes: (key: any) => {},
  seconds: 0,
  setSeconds: (key: any) => {},
  status: '',
  setStatus: (key: any) => {},
})

const OtpContextProvider = (props: any) => {
  const data = JSON.parse(
    localStorage.getItem(local_storage_keys.OTP_CONTEXT) ?? '{}',
  )
  const [userPhoneNumber, setUserPhoneNumber] = useState<string>(
    data.userPhoneNumber ?? '',
  )
  const [userNationalCode, setUserNationalCode] = useState<string>(
    data.userNationalCode ?? '',
  )
  const [userBirthdate, setUserBirthdate] = useState<string>(
    data.userBirthdate ?? '',
  )
  const [otpCode, setOtpCode] = useState<number>(data.otpCode ?? 0)
  const [traceNo, setTraceNo] = useState<string>(data.traceNo ?? '')
  const [minutes, setMinutes] = useState<number>(data.minutes ?? 0)
  const [seconds, setSeconds] = useState<number>(data.seconds ?? 0)
  const [status, setStatus] = useState<number>(data.status ?? 0)

  const otpContext = {
    userPhoneNumber: userPhoneNumber,
    setUserPhoneNumber: setUserPhoneNumber,
    userNationalCode: userNationalCode,
    setUserNationalCode: setUserNationalCode,
    userBirthdate: userBirthdate,
    setUserBirthdate: setUserBirthdate,
    otpCode: otpCode,
    setOtpCode: setOtpCode,
    traceNo: traceNo,
    setTraceNo: setTraceNo,
    minutes: minutes,
    setMinutes: setMinutes,
    seconds: seconds,
    setSeconds: setSeconds,
    status,
    setStatus,
  }

  useEffect(() => {
    const data_storage = {
      userPhoneNumber,
      userNationalCode,
      userBirthdate,
      otpCode,
      traceNo,
      minutes,
      seconds,
      status,
    }

    localStorage.setItem(
      local_storage_keys.OTP_CONTEXT,
      JSON.stringify(data_storage),
    )
  }, [
    userPhoneNumber,
    userNationalCode,
    userBirthdate,
    otpCode,
    traceNo,
    minutes,
    seconds,
    status,
  ])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval)
        } else {
          setSeconds(59)
          setMinutes(minutes - 1)
        }
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [seconds])

  return (
    <OtpContext.Provider value={otpContext}>
      {props.children}
    </OtpContext.Provider>
  )
}

export default OtpContextProvider
